import React from 'react'

export const getConvoName = (users) => {
	if (!users.length || !users[0].user) return ""
	const { first_name, last_name, phone_number, email } = users[0].user
	if (first_name) return `${first_name} ${last_name}`
	else if (email) return email
	else if(phone_number) phone_number
	else return ""
}

export const channelLogo = (channel) => {
	switch (channel) {
		case "EMAIL":
			return <i className="far fa-envelope"></i>
		case "SMS":
			return <i className="fas fa-mobile-alt"></i>
		case "MESSENGER":
			return <i className="fab fa-facebook-messenger"></i>
		case "WEBSITE":
			return <i className="fas fa-globe-americas"></i>
		default:
			return null
	}
}


// WEBPACK FOOTER //
// ./src/utils/convo.js